import { render, staticRenderFns } from "./CappEventCreate.vue?vue&type=template&id=0f0b7351"
import script from "./CappEventCreate.vue?vue&type=script&lang=js"
export * from "./CappEventCreate.vue?vue&type=script&lang=js"
import style0 from "./CappEventCreate.vue?vue&type=style&index=0&id=0f0b7351&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports